module.exports = __webpack_public_path__ + "img/S3.cca89171.png";